import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/PageHeader";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { refreshAssoc } from "@/components/Social";

const FIELDS = [
  ["nome", "Nome Associazione", "sm:col-span-2"],
  ["indirizzo", "Indirizzo", "sm:col-span-2"],
  ["citta", "Città", ""],
  ["cap", "CAP", ""],
  ["email", "Email", ""],
  ["telefono", "Telefono", ""],
  ["codice_fiscale", "Codice fiscale", ""],
  ["iban", "IBAN", ""],
  ["link_app", "Link mobile app", "sm:col-span-2"],
  ["facebook", "Facebook (link al profilo)", "sm:col-span-2"],
  ["instagram", "Instagram (link al profilo)", "sm:col-span-2"],
];

const AnagraficaForm = ({ data, onSaved }) => {
  const [f, setF] = useState(data);
  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = Object.fromEntries(FIELDS.map(([k]) => [k, f[k] || ""]));
      const res = (await api.put("/admin/associazione", payload)).data;
      setF(res);
      onSaved(res);
      toast.success("Anagrafica salvata");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <form onSubmit={save} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="associazione-form">
      {FIELDS.map(([k, label, cls]) => (
        <div key={k} className={cls}>
          <Label>{label}</Label>
          <Input value={f[k] || ""} required={k === "nome"} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`associazione-${k.replace("_", "-")}-input`} />
        </div>
      ))}
      <Button type="submit" className="sm:col-span-2 w-fit bg-emerald-600 hover:bg-emerald-700" data-testid="associazione-save-button">Salva anagrafica</Button>
    </form>
  );
};

const PrivacyForm = ({ data, onSaved }) => {
  const [testo, setTesto] = useState(data.privacy_policy || "");
  const save = async () => {
    try {
      onSaved((await api.put("/admin/privacy", { testo })).data);
      toast.success("Privacy policy pubblicata");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="space-y-3">
      <Textarea rows={14} value={testo} onChange={(e) => setTesto(e.target.value)} placeholder="Testo dell'informativa privacy…" data-testid="privacy-textarea" />
      <div className="flex items-center gap-4">
        <Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="privacy-save-button">Pubblica privacy policy</Button>
        {data.privacy_updated_at && <span className="text-xs text-muted-foreground">Ultimo aggiornamento {fmtDateTime(data.privacy_updated_at)}</span>}
        <a href="/privacy" target="_blank" rel="noreferrer" className="text-sm text-emerald-700 hover:underline" data-testid="privacy-preview-link">Anteprima</a>
      </div>
    </div>
  );
};

const ChiSiamoForm = ({ data, onSaved }) => {
  const [testo, setTesto] = useState(data.chi_siamo || "");
  const save = async () => {
    try {
      onSaved((await api.put("/admin/chi-siamo", { testo })).data);
      toast.success("Testo Chi siamo pubblicato");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="space-y-3">
      <Textarea rows={8} value={testo} onChange={(e) => setTesto(e.target.value)} placeholder="Presentazione dell'associazione mostrata nella pagina iniziale…" data-testid="chi-siamo-textarea" />
      <div className="flex items-center gap-4">
        <Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="chi-siamo-save-button">Pubblica Chi siamo</Button>
        <a href="/associazione#chi-siamo" target="_blank" rel="noreferrer" className="text-sm text-emerald-700 hover:underline" data-testid="chi-siamo-preview-link">Anteprima</a>
      </div>
    </div>
  );
};

export const AssociazioneAdmin = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/associazione").then((r) => setData(r.data));
  }, []);
  if (!data) return null;
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      <Panel>
        <h2 className="font-heading text-2xl uppercase mb-4">Anagrafica Associazione</h2>
        <AnagraficaForm data={data} onSaved={(d) => { setData(d); refreshAssoc(d); }} />
      </Panel>
      <Panel>
        <h2 className="font-heading text-2xl uppercase mb-4">Privacy policy</h2>
        <PrivacyForm data={data} onSaved={setData} />
      </Panel>
      <Panel className="xl:col-span-2">
        <h2 className="font-heading text-2xl uppercase mb-4">Chi siamo</h2>
        <ChiSiamoForm data={data} onSaved={setData} />
      </Panel>
    </div>
  );
};
